import { render, staticRenderFns } from "./apply.vue?vue&type=template&id=238686e4&scoped=true&"
import script from "./apply.vue?vue&type=script&lang=js&"
export * from "./apply.vue?vue&type=script&lang=js&"
import style0 from "./apply.vue?vue&type=style&index=0&id=238686e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238686e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('238686e4')) {
      api.createRecord('238686e4', component.options)
    } else {
      api.reload('238686e4', component.options)
    }
    module.hot.accept("./apply.vue?vue&type=template&id=238686e4&scoped=true&", function () {
      api.rerender('238686e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/permission/apply.vue"
export default component.exports